export enum WarehouseType {
  Wh = 1,
  Res = 2,
  AltPn = 3,
  Wo = 4,
  Ro = 5,
  Px = 6,
  Rn = 7,
}
